var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('Stat'),_c('RevenueAnalytics')],1),_c('div',{staticClass:"col-xl-4"},[_c('RemittanceAnalytics'),_c('BusinessConditions')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }